import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useProfile } from "@/hooks/useProfile";
import { Loader2 } from "lucide-react";

const MySPAIProfile = () => {
  const { user } = useAuth();
  const { profile, isLoading } = useProfile();
  const navigate = useNavigate();

  // Redirect to dynamic profile page if username exists, or to create profile if not
  useEffect(() => {
    if (!isLoading) {
      if (profile?.username) {
        navigate('/creators', { replace: true });
      } else {
        navigate('/create-myspai-profile', { replace: true });
      }
    }
  }, [profile, isLoading, navigate]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  // Show loading while redirecting
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  );
};

export default MySPAIProfile;
